const isTitleAlign = (type) => {
  return !['hyperLink','caption', 'divider'].includes(type)
}

export {
  isTitleAlign,
}